import React, { Component } from 'react';
import { Tabs } from 'antd';
/** Personal Components */
import Stem from '../NormalStem';
import Footer from '../Footer';
import SubQuestion from './sub-question';
/** Personal Js */
import { reverseParseTextView } from './createRender';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);
const { TabPane } = Tabs;

class Exercise extends Component {
    constructor(props) {
        super(props);

        let childExerciseMap = {};
        props.obj.sub_list.forEach(item => {
            //子题对象。key：题号，value：题目详情。
            childExerciseMap[item.number] = item;
        });

        this.state = {
            data: reverseParseTextView(props.obj),
            childExerciseMap, //子题对象。key：题号，value：题目详情。
        };
    }

    componentDidMount() {
        this.MQLoad();
    }

    componentDidUpdate() {
        this.MQLoad();
    }

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            // 然而, 我们这里并不是可编辑的
            MQ.StaticMath(item);
        });
    };

    childHtml = (data, stage) => {
        const { showId, showLocal, showRight, showType, showDifficulty, showRate, showTrain, showKnowledge } = this.props;
        const props = {
            showId,
            showLocal,
            showRight,
            showType,
            showDifficulty,
            showRate,
            showTrain,
            showKnowledge,
            stage,
            data
        };
        return <SubQuestion {...props} key={data.number} />;
    };

    renderChildNode = (node, list) => {
        const { childExerciseMap } = this.state;
        // 优先渲染自身节点
        list.push(this.childHtml(childExerciseMap[node.number], node.stage));
        // 其次渲染孩子节点
        // 若其有多个孩子节点，表明该题是分支题
        // 若只有一个孩子节点，表明该题是普通题
        if (node.children.length === 1) {
            this.renderChildNode(node.children[0], list);
        } else if (node.children.length > 1) {
            const branchNode = (
                <div key={Math.random()} style={{ padding: '0 30px 30px' }}>
                    <Tabs>
                        {
                            node.children.map((n, i) =>
                                <TabPane key={node.branchs[i]} tab={node.branchs[i]}>
                                    {
                                        this.renderChildNode(n, [])
                                    }
                                </TabPane>
                            )
                        }
                    </Tabs>
                </div>
            );
            list.push(branchNode);
        }
        return list;
    };

    render() {
        const { data } = this.state;
        const { num } = this.props;
        // 子题节点列表
        const childNode = this.renderChildNode(data.answer[0], []);


        return (
            <div className="question-wrapper question-step" ref={el => this.viewer = el}>
                <div className="question-content" style={{ borderBottom: '1px solid #e9edf6', padding: '30px 16px' }}>
                    <div className="question-order">
                        <p className="math_text">
                            <span>{`${num + 1}.`}</span>
                        </p>
                    </div>
                    <div className="question-stem">
                        <Stem stem={data.stem} />
                    </div>
                </div>
                <div className="question-footer">
                    <div className="footer-show">
                        <Footer {...this.props} />
                    </div>
                </div>
                {childNode}
            </div>
        )
    }
}

export default Exercise;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/view.js